import { render, staticRenderFns } from "./CaptureWelcome.vue?vue&type=template&id=324afabe&scoped=true"
import script from "./CaptureWelcome.vue?vue&type=script&lang=js"
export * from "./CaptureWelcome.vue?vue&type=script&lang=js"
import style0 from "./CaptureWelcome.vue?vue&type=style&index=0&id=324afabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324afabe",
  null
  
)

export default component.exports